import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { SIZES } from '../Common/constants';

import ClearIcon from 'dibs-icons/exports/Close';
import { StyledButton } from '../Common/Button/StyledButton';

// styles
import styles from './main.scss';

const { small, medium, large } = SIZES;

type PropsType = {
    dataTn: string;
    size: typeof small | typeof medium | typeof large;
    onClear?: () => void;
    disabled?: boolean;
    isHidden?: boolean;
};

export const ClearButton: FunctionComponent<PropsType> = props => {
    const { dataTn, size, onClear = () => {}, disabled = false, isHidden = true } = props;

    // default to medium size
    let sizeClear = styles.mediumClear;
    if (size === 'small') {
        sizeClear = styles.smallClear;
    } else if (size === 'large') {
        sizeClear = styles.largeClear;
    }

    const clearButtonClasses = classnames(styles.fullyTransparent, {
        [styles.defaultClear]: !size,
        [sizeClear]: !!size,
        [styles.hideCloseButton]: isHidden,
        [styles.showCloseButton]: !isHidden,
    });

    const buttonProps = {
        className: clearButtonClasses,
        dataTn,
        disabled,
        isPrimary: false,
        onClick: onClear,
        tabIndex: isHidden ? -1 : undefined,
    };

    return (
        <StyledButton ariaLabel="Clear search terms" type="button" {...buttonProps}>
            <ClearIcon />
        </StyledButton>
    );
};
